import { Account } from './account';
import { Injectable } from '@angular/core';
import { environment } from "../environments/environment";

/**
 * Application globals
 *
 * @author amchavan
 * @author rkurowsk
 */
@Injectable({ providedIn: 'root' })
export class GlobalsService {

    public apiURL: string;
    public resourceServerURL: string;
    public adminURL: string;

    // public user: string;
    account : Account | undefined;    // Set by the startup procedure
    impersonated : boolean = false;
    accountId = "";
    impersonatedName?: string;

    constructor() {

      this.resourceServerURL = environment['resourceServerURL'];
      this.apiURL = environment['apiURL'];

        // If we are served from 'ng serve' our URL is going to be something like http://localhost:4200,
        // we'll take that to mean the app is running in a development environment. That is,
        // our resource server is on a different URL than us
        if (document.URL.indexOf(':42') >= 0) {

            const hostname = (new URL(document.URL)).hostname;
            const urlPrefix = 'http://' + hostname + ':10012';
            this.apiURL = urlPrefix + this.apiURL;
            this.resourceServerURL = urlPrefix + this.resourceServerURL;
        }

        this.adminURL = this.resourceServerURL + "/admin";
    }
}
